<template>
  <v-dialog v-model="show" max-width="1200" persistent v-if="show">
    <v-card style="padding:15px;">
      <span style="font-size:20px;font-weight:bold;">
        El usuario seleccionado tiene más de una dirección, seleccione la que desea utilizar para
        este envio.
      </span>
      <v-data-table
        @click:row="rowClick"
        hide-default-footer
        :headers="headers"
        :items="direcciones"
        single-select
        item-key="id"
      >
      </v-data-table>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" @click="cierraDialogo()" text>Cancelar</v-btn>
        <v-btn color="blue darken-1" @click="direccionElegidaM()" text>Aceptar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    show: Boolean,
    usuarioAChecarDirecciones: Object
  },
  data: () => ({
    usuarioDireccionesIterable: {},
    direcciones: [],
    direccionElegida: "",

    headers: [
      {
        text: "CIUDAD",
        align: "center",
        sortable: true,
        value: "ciudad"
      },
      {
        text: "COLONIA",
        align: "center",
        sortable: true,
        value: "colonia"
      },
      {
        text: "C.P.",
        align: "center",
        sortable: true,
        value: "cp"
      },
      {
        text: "DIRECCIÓN",
        align: "center",
        sortable: true,
        value: "direccion"
      },
      {
        text: "ESTADO",
        align: "center",
        sortable: true,
        value: "estado"
      },
      {
        text: "PAÍS",
        align: "center",
        sortable: true,
        value: "pais"
      }
    ]
  }),
  mounted() {
    this.usuarioDireccionesIterable.direccion = Array.from(
      JSON.parse(this.usuarioAChecarDirecciones.DIRECCION)
    );

    //comprobamos si existe dato de pais, si existe se asigna a un arreglo de paises a iterar
    // sino llenamos con mexico por defecto
    if (this.usuarioAChecarDirecciones.PAIS) {
      this.usuarioDireccionesIterable.pais = Array.from(
        JSON.parse(this.usuarioAChecarDirecciones.PAIS)
      );
    } else {
      this.usuarioDireccionesIterable.pais = [];
      for (let i = 0; i < this.usuarioDireccionesIterable.direccion.length; i++) {
        this.usuarioDireccionesIterable.pais.push("México");
      }
    }

    this.usuarioDireccionesIterable.ciudad = Array.from(
      JSON.parse(this.usuarioAChecarDirecciones.MUNICIPIO)
    );
    this.usuarioDireccionesIterable.estado = Array.from(
      JSON.parse(this.usuarioAChecarDirecciones.ESTADO)
    );
    this.usuarioDireccionesIterable.cp = Array.from(
      JSON.parse(this.usuarioAChecarDirecciones.CODIGO_POSTAL)
    );
    this.usuarioDireccionesIterable.colonia = Array.from(
      JSON.parse(this.usuarioAChecarDirecciones.COLONIA)
    );
    for (let i = 0; i < this.usuarioDireccionesIterable.direccion.length; i++) {
      this.direcciones.push({
        direccion: this.usuarioDireccionesIterable.direccion[i],
        ciudad: this.usuarioDireccionesIterable.ciudad[i],
        estado: this.usuarioDireccionesIterable.estado[i],
        cp: this.usuarioDireccionesIterable.cp[i],
        colonia: this.usuarioDireccionesIterable.colonia[i],
        pais: this.usuarioDireccionesIterable.pais[i],
        id: i
      });
    }
  },
  methods: {
    cierraDialogo() {
      this.$emit("cierraModalDirecciones");
    },
    rowClick(item, row) {
      row.select(true);
      this.direccionElegida = item;
    },
    direccionElegidaM() {
      this.$emit("elegi-esta-direccion", this.direccionElegida.id);
      //   console.log(this.direccionElegida.id);
    }
  }
};
</script>
